import type { Testimonial } from '../testimonials'

export const added: Testimonial = {
  // The mark arrived on 2026-08-28 ("epic museum logo hall of fame için") —
  // the museum's own 400×108 teal wordmark, so this card is no longer the one
  // headed by its name alone. It is a wide wordmark rather than one of the
  // 300×300 `*card.png` squares, which `fit="quote"` handles: every mark on
  // this page is drawn at one width regardless of shape. If the file turns
  // out to carry no alpha channel it will print as a white block on the
  // card's grey — see `TESTIMONIALS_CHECK`.
  company: 'Epic Museum',
  logo: { name: 'Epic Museum', src: '/logo/epicmuseum.webp' },
  portrait: { src: '/photo/portrait-luke-smith.png', alt: 'Luke Smith' },
  quote: [
    'The Digitopia Impact Platform provided us with great insights into our sustainability '
    + 'maturity. We love the actionable recommendations the system generated to help '
    + 'prioritise our sustainability initiatives. It created an achievable plan to deliver '
    + 'those recommendations, serving as a powerful tool to improve our sustainability '
    + 'maturity.',
  ],
  attribution: 'Luke Smith, Director of Technology',
}

/** Its place on the wall — the order the live page lists them in. */
export const order = 18
